<template>

  <nav class="cliente-modal-tab-bar" role="tablist">

    <div class="cliente-modal-tab-bar__tabs">

      <button

        v-for="tab in tabs"

        :key="tab.id"

        type="button"

        role="tab"

        class="cliente-modal-tab-bar__item"

        :class="{ 'cliente-modal-tab-bar__item--active': modelValue === tab.id }"

        :aria-selected="modelValue === tab.id"

        @click="$emit('update:modelValue', tab.id)"

      >

        <span v-if="tab.icon" class="cliente-modal-tab-bar__icon" v-html="tab.icon" />

        <span class="cliente-modal-tab-bar__label">{{ tab.label }}</span>

      </button>

    </div>

    <div v-if="$slots.actions" class="cliente-modal-tab-bar__actions">

      <slot name="actions" />

    </div>

  </nav>

</template>



<script setup>

defineProps({

  tabs: { type: Array, required: true },

  modelValue: { type: String, required: true }

})



defineEmits(['update:modelValue'])

</script>



<style scoped>

.cliente-modal-tab-bar {

  display: flex;

  align-items: stretch;

  gap: 0.35rem;

  padding: 0.5rem 0.75rem;

  border-bottom: 1px solid var(--border-primary, #e5e7eb);

  background: var(--bg-secondary, #f8fafc);

  flex-shrink: 0;

}



.cliente-modal-tab-bar__tabs {

  display: flex;

  flex: 1 1 auto;

  gap: 0.25rem;

  min-width: 0;

  overflow-x: auto;

}



.cliente-modal-tab-bar__actions {

  display: flex;

  align-items: center;

  flex-shrink: 0;

  margin-left: auto;

  padding-left: 0.25rem;

}



.cliente-modal-tab-bar__item {

  display: inline-flex;

  align-items: center;

  gap: 0.5rem;

  padding: 0.625rem 1rem;

  margin: 2px 0;

  border-radius: 4px;

  background: transparent;

  border: none;

  color: var(--text-secondary, #64748b);

  font-size: 0.875rem;

  font-weight: 500;

  white-space: nowrap;

  cursor: pointer;

  transition: all 0.2s ease;

  position: relative;

}

.cliente-modal-tab-bar__item:hover {

  background-color: rgba(0, 0, 0, 0.05);

  color: var(--text-primary, #0f172a);

  transform: translateX(2px);

  border-left: 2px solid transparent;

}

:global(body.tema_clara) .cliente-modal-tab-bar__item:hover {

  border-left-color: #000;

}

:global(body.tema_escura) .cliente-modal-tab-bar__item:hover {

  background-color: var(--bg-hover);

  color: var(--text-primary);

}

.cliente-modal-tab-bar__item--active {

  background-color: var(--bg-card);

  color: var(--text-primary);

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

}

:global(body.tema_escura) .cliente-modal-tab-bar__item--active {

  background-color: var(--bg-hover);

  color: var(--text-primary);

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);

}

.cliente-modal-tab-bar__icon {

  width: 1.125rem;

  height: 1.125rem;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

}

.cliente-modal-tab-bar__icon :deep(svg) {

  width: 1.125rem;

  height: 1.125rem;

}

</style>


